import { skipToken } from '@reduxjs/toolkit/query';
import { InlineMessage } from '@strata/react-inline-message';
import { useFormikContext } from 'formik';

import {
    ALL_PAYERS,
    AutomationRuleActions,
    AutomationRuleCriteria,
    type AutomationRuleFormContext,
    findAutomationRuleCriterionValue,
} from 'services/AutomationRuleHelpers';
import { useGetDefaultRatesForProductQuery } from 'store/api/rateSetterApi';

export const FrozenPriceNote = () => {
    const formik = useFormikContext<AutomationRuleFormContext>();

    const selectedSegment = findAutomationRuleCriterionValue(
        formik.values.criteria,
        AutomationRuleCriteria.PAYER,
    );
    const payerId = selectedSegment?.id !== ALL_PAYERS ? selectedSegment?.payerId : undefined;
    const productServiceOid = findAutomationRuleCriterionValue(
        formik.values.criteria,
        AutomationRuleCriteria.PRODUCT,
    )?.oid;
    const placeOfService = findAutomationRuleCriterionValue(
        formik.values.criteria,
        AutomationRuleCriteria.PLACE_OF_SERVICE,
    )?.id;
    const isBrand = findAutomationRuleCriterionValue(
        formik.values.criteria,
        AutomationRuleCriteria.PRODUCT,
    )?.isBrand;
    const { data: defaultRates, isFetching } = useGetDefaultRatesForProductQuery(
        productServiceOid && isBrand != null
            ? {
                  payerId,
                  productServiceOid,
                  placeOfService,
                  isBrand,
              }
            : skipToken,
    );

    const isFrozen =
        formik.values.action?.type === AutomationRuleActions.SET_MAX_BID &&
        formik.values.action.value?.some(
            (value) =>
                defaultRates?.find((rate) => rate.referentPriceType === value.referentPriceType)
                    ?.isFrozen,
        );

    return !isFetching && isFrozen ? (
        <InlineMessage
            intent={InlineMessage.Intent.INFO}
            wrapText
            label="Servicing unit price will be locked at the servicing start date for the life of referrals assigned with this template rule."
        />
    ) : null;
};
